"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleResponse = void 0;
var _constants = require("../constants");
/**
 * Safely handle and return data on Axios response based on its status.
 */ var handleResponse = function(response, param) {
    var onError = param.onError, onSuccess = param.onSuccess;
    return response.status === _constants.STATUS_OK ? onSuccess(response) : onError(response);
};
exports.handleResponse = handleResponse; //# sourceMappingURL=handleResponse.js.map
